<template>
    <v-card elevation="0" class="ai-content-and-share-tab rounded-0 pa-4"
        :class="$vuetify.theme.dark ? 'transparent' : 'transparent'">
        <v-row justify="center">
            <v-col cols="12" md="10" lg="8">
                <v-btn text small class="mb-3" @click="$router.push('/news')">
                    <v-icon left>mdi-arrow-left</v-icon> Back to News
                </v-btn>

                <v-skeleton-loader v-if="isLoading" type="article" class="mt-4"></v-skeleton-loader>

                <div v-else-if="newsDetails">
                    <h2>{{ newsDetails.name }}</h2>
                    <p class="text-subtitle-2 grey--text">
                        Category: {{ newsDetails.category_name || 'N/A' }}
                    </p>
                    <p class="text-caption grey--text">
                        Published: {{ formatDate(newsDetails.created_at) }}
                    </p>

                    <v-divider class="my-3"></v-divider>

                    <div v-html="newsDetails.description"></div>
                </div>

                <div v-else class="text-center grey--text mt-10">
                    <v-icon size="60" color="grey lighten-1">
                        mdi-newspaper-variant-outline
                    </v-icon>
                    <p class="mt-2">News not found or not published.</p>
                </div>
            </v-col>
        </v-row>
    </v-card>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { NEWS__ACTIONS } from "@/store/action-types";

export default {
    data() {
        return {
            isLoading: false,
        };
    },

    computed: {
        ...mapState("news", ["newsCategoriesdetails"]),
        newsDetails() {
            return this.newsCategoriesdetails;
        },
    },

    methods: {
        ...mapActions("news", [NEWS__ACTIONS.VIEWNEWSDETAILS]),

        async loadNews() {
            const id = this.$route.params.id;
            if (!id) return;

            try {
                this.isLoading = true;
                await this[NEWS__ACTIONS.VIEWNEWSDETAILS](id);
            } finally {
                this.isLoading = false;
            }
        },

        formatDate(dateStr) {
            if (!dateStr) return "N/A";
            const date = new Date(dateStr);
            return date.toLocaleString("en-US", {
                year: "numeric",
                month: "short",
                day: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },
    },

    async mounted() {
        await this.loadNews();
    },
};
</script>
